export const ROUTES_MAIL_ROOT = '/mail'
export const ROUTES_MAIL_INBOX = '/mail/inbox'
export const ROUTES_MAIL_NEW = '/mail/new'
export const ROUTES_MAIL_SENT = '/mail/sent'
